import { Box, MenuItem, TextField, Typography, useMediaQuery } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import { PROFILE_IMAGE_TYPE } from 'Queries/utils'
import React, { useContext } from 'react'
import { When } from 'react-if'
import Avatar from 'Theme/Avatar'
import FAIcon from 'Theme/FAIcon'
import CustomMuiSelect from 'Theme/Select'
import { userImageSelector } from 'utils/user-images-utils'

import { useContestRoundsQuery, useDeleteJudgeMutation } from '../../../../../Queries/Contests'
import { BREAKPOINT_MIN_LG } from '../../../../../Theme/stylesUtil'
import { NotificationContext } from '../../../../Notification/context'
import { JUDGE_STATUSES, SOCIAL_NETWORKS_ICONS } from '../constants'
import { JudgesRoundSelector } from './JudgesRoundSelector'

const Flag = React.lazy(() => import(/* webpackChunkName: "react-world-flags" */ 'react-world-flags'))

const useStyles = makeStyles((theme) => ({
  flag: {
    borderRadius: theme.shape.borderRadius * 0.375,
  },
  biography: {
    wordBreak: 'break-all',
  },
}))

export const JudgeInfo = ({
  judge,
  handleChangeRounds,
  handleChangeRole,
  handleChangeStatus,
  contestId,
  roundLimits,
}) => {
  const { notification } = useContext(NotificationContext)
  const { data: roundNames } = useContestRoundsQuery(roundLimits)
  const { mutate: deleteJudge } = useDeleteJudgeMutation(contestId)
  const handleDeleteJudge = (judgeId) => {
    deleteJudge(
      { contestId, judgeId },
      {
        onSuccess: () => {
          notification.success(`You have successfully removed ${judge.login} from contest`)
        },
      },
    )
  }
  const classes = useStyles()
  const isBiggerThanLGScreen = useMediaQuery(BREAKPOINT_MIN_LG)
  return (
    <Box
      display="flex"
      flexDirection={isBiggerThanLGScreen ? 'row' : 'column'}
      gap={1}
    >
      <When condition={isBiggerThanLGScreen}>
        <Box
          display="flex"
          gap={3}
          minWidth={'500px'}
        >
          <Avatar
            src={userImageSelector(judge?.user_images, PROFILE_IMAGE_TYPE.AVATAR, 'large')}
            size="mobileLarge"
          />

          <Box
            display="flex"
            flexDirection="column"
            gap={1}
          >
            <Typography
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '250px',
              }}
              variant="h3"
            >
              {judge?.login}
            </Typography>
            {judge?.firstname && (
              <Box
                display="flex"
                gap={2}
                alignItems="center"
              >
                <Box
                  display="flex"
                  gap={1}
                  alignItems="center"
                >
                  <Flag
                    code={'UA'}
                    width="18px"
                    height="10px"
                    className={classes.flag}
                  />
                  <Typography
                    variant="body2"
                    color="text.tertiary"
                    sx={{
                      fontWeight: '700',
                    }}
                  >
                    {judge?.firstname}
                  </Typography>
                </Box>
                <Typography
                  variant="body2"
                  color="text.tertiary"
                  sx={{
                    fontWeight: '700',
                  }}
                >
                  {judge?.secondname}
                </Typography>
              </Box>
            )}
            <Typography
              variant="body2"
              color="text.secondary"
            >
              {judge?.profile?.biography}
            </Typography>
            <Box
              display="flex"
              gap={1}
            >
              {Object.keys(SOCIAL_NETWORKS_ICONS).map((item) =>
                judge?.profile?.[`link_${item}`] ? (
                  <FAIcon
                    key={item}
                    iconFontSize={12}
                    iconClassName={SOCIAL_NETWORKS_ICONS[item]}
                    color="text.tertiary"
                  />
                ) : null,
              )}
            </Box>
          </Box>
        </Box>
      </When>
      <Box
        display="flex"
        flexDirection="column"
        gap={2}
        alignItems="flex-end"
      >
        <TextField
          value={judge?.role || ''}
          placeholder="Enter title"
          sx={{ width: !isBiggerThanLGScreen ? '100% !important' : 'auto' }}
          onChange={(e) => handleChangeRole(e.target.value)}
        />
        <When condition={isBiggerThanLGScreen}>
          <CustomMuiSelect value={judge.status || 'judge'}>
            {Object.keys(JUDGE_STATUSES).map((item) => (
              <MenuItem
                value={item}
                key={item}
                onClick={() => handleChangeStatus(item)}
              >
                {JUDGE_STATUSES[item]}
              </MenuItem>
            ))}
          </CustomMuiSelect>
          <JudgesRoundSelector
            roundNames={roundNames}
            judge={judge}
            onSelect={handleChangeRounds}
            handleDeleteJudge={handleDeleteJudge}
          />
        </When>
      </Box>
      <When condition={!isBiggerThanLGScreen}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <CustomMuiSelect value={judge.status || 'judge'}>
            {Object.keys(JUDGE_STATUSES).map((item) => (
              <MenuItem
                value={item}
                key={item}
                onClick={() => handleChangeStatus(item)}
              >
                {JUDGE_STATUSES[item]}
              </MenuItem>
            ))}
          </CustomMuiSelect>
          <JudgesRoundSelector
            roundNames={roundNames}
            judge={judge}
            onSelect={handleChangeRounds}
            handleDeleteJudge={handleDeleteJudge}
          />
        </Box>
      </When>
    </Box>
  )
}
